import { render, staticRenderFns } from "./PartnerOrganisation.vue?vue&type=template&id=87e52ab4"
import script from "./PartnerOrganisation.vue?vue&type=script&lang=js"
export * from "./PartnerOrganisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports